import { Chip } from "@mui/material";
import badgeCircle from "assets/svg/badgeCircle.svg";
import badgeFullCircle from "assets/svg/badgeFullCircle.svg";
import badgePartiallyRefunded from "assets/svg/badgePartiallyRefunded.svg";
import badgeProcessing from "assets/svg/badgeProcessing.svg";
import badgeX from "assets/svg/badgeX.svg";
import { PiCaretDownBold } from "react-icons/pi";

export const BADGE_FULFILLMENT_STATUS_MAP: Record<string, { text: string; color: string; icon: string }> = {
    ORDER_RECEIVED: { text: "Order Received", color: "#F5F5F5", icon: badgeCircle },
    READY_TO_PACK: { text: "Ready to Pack", color: "#E3F2FD", icon: badgeProcessing },
    PACKAGED: { text: "Packaged", color: "#9EC6F3", icon: badgeFullCircle },
    LABEL_CREATED: { text: "Label Created", color: "#B0B4F2", icon: badgeFullCircle },
    READY_FOR_PICK_UP: { text: "Ready for Pick Up", color: "#F2D8B0", icon: badgeCircle },
    SHIPPED: { text: "Shipped", color: "#B0B4F2", icon: badgeFullCircle },
    CANCELED: { text: "Canceled", color: "#FFB2B2", icon: badgeX },
    DELIVERED: { text: "Delivered", color: "#D9F9BA", icon: badgeFullCircle },
    PARTIALLY_REFUNDED: { text: "Partially Refunded", color: "#B0F2D2", icon: badgePartiallyRefunded },
    RETURNED: { text: "Returned", color: "#FFB2B2", icon: badgeX },
};

export default function BadgeFulfillment(props: any) {
    
    const fulfillmentStatus = props?.code || 'ORDER_RECEIVED';
    const status = BADGE_FULFILLMENT_STATUS_MAP[fulfillmentStatus] ?? BADGE_FULFILLMENT_STATUS_MAP['ORDER_RECEIVED'];
    const additional_text = props?.additional_text ? ` ${props.additional_text}` : "";
    const showDropdownIcon = props?.showDropdownIcon || false;
    const classNames = ['order-details-status'];

    if (showDropdownIcon) {
        classNames.push('order-details-dropdown');
    }

    if (props?.className) {
        classNames.push(props.className);
    }

    return (
        <Chip
            label={
                <>
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <img src={status.icon} alt="" style={{ width: 10, height: 10 }} className="badge-icon" />
                        {status.text} {additional_text}
                    </span>
                    {showDropdownIcon && <PiCaretDownBold size={16} />}
                </>
            }
            className={classNames.join(' ')}
            sx={{
                '& .MuiChip-label': {
                    padding: '0 12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: showDropdownIcon ? '30px' : '0px',
                }
            }}
            style={{
                borderRadius: "5px",
                fontSize: "14px",
                backgroundColor: status.color,
                color: "#424242",
                fontWeight: "400",
                height: "29px",
                width: showDropdownIcon ? "100%" : "auto",
            }}
        />
    );
}